import React, { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function CircularProgress({ seconds = 60, width = 54, height = 54 }) {
  const [timer, setTimer] = useState(seconds);

  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${Math.abs(minutes)}:${secs < 10 ? "0" : ""}${parseInt(Math.abs(secs))}`;
  };

  return (
    <div style={{ width: width, height: height }}>
      <CircularProgressbar
        value={(timer / seconds) * 100}
        minValue={0}
        maxValue={100}
        text={formatTime(timer)}
        styles={{
          path: { stroke: `#FFF`, strokeWidth: 4 },
          trail: { stroke: `#334e85`, strokeWidth: 4 },
          text: { fill: "#FFF", fontSize: "24px" },
        }}
      />
    </div>
  );
}
